export const END_SCREENSHARE = 'events/END_SCREENSHARE';

/**
 * @return {{type: string}}
 */
export const endScreenShare = (payload) => ({ type: END_SCREENSHARE, payload });
